module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/record-66f9b2300554e9e929ae3a252e90b2bf.svg";